import { defineSemanticTokens } from "@chakra-ui/react";

export const colors = defineSemanticTokens.colors({
  bg: {
    DEFAULT: {
      value: {
        _light: "{colors.gray.50}",
      },
    },
    accent: {
      value: {
        _light: "{colors.redOrange.500}",
      },
    },
    error: {
      value: {
        _light: "{colors.red.100}",
      },
    },
    inverted: {
      value: {
        _light: "{colors.blackAlpha.0}",
      },
    },
    overlay: {
      value: {
        _light: "#00000080",
      },
    },
    panel: {
      value: {
        _light: "{colors.whiteAlpha.0}",
      },
    },
    subtle: {
      value: {
        _light: "{colors.whiteAlpha.0}",
      },
    },
    success: {
      value: {
        _light: "{colors.yellowGreen.100}",
      },
    },
    warning: {
      value: {
        _light: "{colors.yellow.50}",
      },
    },
  },
  blue: {
    contrast: {
      value: {
        _light: "{colors.whiteAlpha.0}",
      },
    },
    focusRing: {
      value: {
        _light: "{colors.blue.400}",
      },
    },
  },
  border: {
    success: {
      value: {
        _light: "{colors.yellowGreen.500}",
      },
    },
    warning: {
      value: {
        _light: "{colors.redOrange.500}",
      },
    },
  },
  brand: {
    contrast: {
      value: {
        _light: "{colors.whiteAlpha.0}",
      },
    },
    emphasized: {
      value: {
        _light: "{colors.redOrange.300}",
      },
    },
    fg: {
      value: {
        _light: "{colors.redOrange.500}",
      },
    },
    focusRing: {
      value: {
        _light: "{colors.redOrange.500}",
      },
    },
    muted: {
      value: {
        _light: "{colors.redOrange.50}",
      },
    },
    solid: {
      value: {
        _light: "{colors.redOrange.500}",
      },
    },
    subtle: {
      value: {
        _light: "{colors.redOrange.100}",
      },
    },
  },
  fg: {
    DEFAULT: {
      value: {
        _light: "{colors.blackAlpha.0}",
      },
    },
    accent: {
      value: {
        _light: "{colors.redOrange.500}",
      },
    },
    subtle: {
      value: {
        _light: "{colors.gray.500}",
      },
    },
    success: {
      value: {
        _light: "{colors.yellowGreen.500}",
      },
    },
    warning: {
      value: {
        _light: "{colors.yellow.500}",
      },
    },
  },
  gray: {
    contrast: {
      value: {
        _light: "{colors.whiteAlpha.0}",
      },
    },
    fg: {
      value: {
        _light: "{colors.gray.900}",
      },
    },
    muted: {
      value: {
        _light: "{colors.gray.0}",
      },
    },
    subtle: {
      value: {
        _light: "{colors.whiteAlpha.0}",
      },
    },
  },
  green: {
    contrast: {
      value: {
        _light: "{colors.whiteAlpha.0}",
      },
    },
    emphasized: {
      value: {
        _light: "{colors.yellowGreen.300}",
      },
    },
    fg: {
      value: {
        _light: "{colors.yellowGreen.700}",
      },
    },
    focusRing: {
      value: {
        _light: "{colors.yellowGreen.400}",
      },
    },
    muted: {
      value: {
        _light: "{colors.yellowGreen.200}",
      },
    },
    solid: {
      value: {
        _light: "{colors.yellowGreen.600}",
      },
    },
    subtle: {
      value: {
        _light: "{colors.yellowGreen.100}",
      },
    },
  },
  red: {
    contrast: {
      value: {
        _light: "{colors.whiteAlpha.0}",
      },
    },
    focusRing: {
      value: {
        _light: "{colors.red.400}",
      },
    },
  },
  text: {
    fg: {
      value: {
        _light: "{colors.gray.950}",
      },
    },
    fg_accent: {
      value: {
        _light: "{colors.redOrange.600}",
      },
    },
    fg_error: {
      value: {
        _light: "{colors.red.500}",
      },
    },
    fg_info: {
      value: {
        _light: "{colors.blue.600}",
      },
    },
    fg_inverted: {
      value: {
        _light: "{colors.gray.50}",
      },
    },
    fg_muted: {
      value: {
        _light: "{colors.gray.600}",
      },
    },
    fg_subtle: {
      value: {
        _light: "{colors.gray.400}",
      },
    },
    fg_success: {
      value: {
        _light: "{colors.yellowGreen.600}",
      },
    },
    fg_warning: {
      value: {
        _light: "{colors.yellow.600}",
      },
    },
  },
  yellow: {
    contrast: {
      value: {
        _light: "{colors.whiteAlpha.0}",
      },
    },
    fg: {
      value: {
        _light: "{colors.yellow.900}",
      },
    },
    focusRing: {
      value: {
        _light: "{colors.yellow.400}",
      },
    },
    solid: {
      value: {
        _light: "{colors.yellow.500}",
      },
    },
  },
});
